import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="London">
                <h1>Android App Development Company in UK</h1>
              </div>
              <p className="main_para">
                TekRevol stands out as a bespoke Android app development company
                in UK, dedicated to developing apps that prioritize customers
                and offer a smooth user experience. As a custom Android
                development company, our expertise lies in providing innovative
                solutions for Android, turning your app ideas into reality.
                Collaborate with us now to start your journey of Android app
                development excellence, propelling your business to new heights!
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
